// eslint-disable-next-line no-control-regex,max-len
export const emailValidatorRegExp = /(?:[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(([a-zA-Z\d]{1,63}\.)|([a-zA-Z\d][a-zA-Z\d-]{0,61}[a-zA-Z\d]\.))+[a-zA-Z]{2,6}$/;

const validateEmail = (email: string): boolean => emailValidatorRegExp.test(email);

export default validateEmail;
